import { Fragment, useEffect, useState } from "react";
import { Divider, Grid } from "@mui/material";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

//import view components
import PassengersFormContainer from "./passengers-form-container";

function IntHotelNestedForm({ control, register, defaultValues, watch, getValues, setValue, resetField, errors, roomIndex, isPassengersModalOpen }) {
    //general variables
    const { t } = useTranslation();
    const [IDcard, setIDcard] = useState([]);

    //sessionStorage variables
    const { originRoomsCount, nationality } = JSON.parse(sessionStorage.getItem("hotelInformation"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));

    //passenger type code
    const PASSENGER_TYPE_CODES = {
        adult: "adt",
        child: "chd",
        infant: "inf",
    };

    const { fields: forms } = useFieldArray({
        control,
        name: `rooms.${roomIndex}.passengers`,
    });

    //passengers type array
    const [passengerData, setPassengerData] = useState(null);
    const createPassengerData = rooms => {
        return rooms.map(room => {
            const passengers = [];

            for (let i = 0; i < room.adult; i++) {
                passengers.push({ type: "adult", age: "" });
            }

            for (let i = 0; i < room.child; i++) {
                if (room.childAges[i]) {
                    passengers.push({
                        type: "child",
                        age: room.childAges[i],
                    });
                } else {
                    passengers.push({ type: "child", age: "" });
                }
            }

            return passengers;
        });
    };
    useEffect(() => {
        const data = createPassengerData(originRoomsCount);
        setPassengerData(data);
    }, []);

    //value for id and rate plan id rooms
    useEffect(() => {
        passengerData?.[roomIndex]?.forEach((room, index) => {
            const gender = watch(`rooms.${roomIndex}.passengers.${index}.gender`);
            setValue(`rooms.${roomIndex}.passengers.${index}.title`, gender?.id === 1 ? "MR" : gender?.id === 2 ? "MRS" : "");
            setValue(`rooms.${roomIndex}.passengers.${index}.type`, PASSENGER_TYPE_CODES[room?.type]);
            setValue(`rooms.${roomIndex}.passengers.${index}.age`, room?.age);
            setValue(`rooms.${roomIndex}.passengers.${index}.nationality`, nationality);
        });
    }, [forms, passengerData, isPassengersModalOpen]);

    return (
        <Grid className="passengers__forms" container item xs={12} rowGap={5}>
            {forms.map((form, formIndex) => {
                return (
                    <Fragment key={form.id}>
                        <PassengersFormContainer
                            roomIndex={roomIndex}
                            formIndex={formIndex}
                            formType="intHotel"
                            passengerType={
                                t(`${passengerData?.[roomIndex]?.[formIndex]?.type}`) + (passengerData?.[roomIndex]?.[formIndex]?.age?.name || "")
                            }
                            form={form}
                            formCount={Object.values(selectedIntRooms?.rooms)}
                            IDcard={IDcard}
                            setIDcard={setIDcard}
                            nestedName={`rooms.${roomIndex}.`}
                            {...{ control, register, defaultValues, watch, getValues, setValue, resetField, errors }}
                        />
                        {formIndex < forms?.length - 1 && <Divider width="100%" />}
                    </Fragment>
                );
            })}
        </Grid>
    );
}

export default IntHotelNestedForm;
